import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import renderViewsState from '../shared/render-views-state';
import { baseUrl } from '../../config/route-entry-point';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import isEmpty from 'lodash/isEmpty';
import Manager from '../shared/manager';

lessRequire('modules/master-account/main.less');

const Main = renderViewsState(props => {
	const {intl} = props;

	return (
		<div className="container__with-columns container master-container">
			<div className="column_left container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{intl('Работаешь командой? Тебе сюда.')}</h2>
				</div>
				<div className="container__content-description">
					{intl('Подключи функцию мастер-аккаунта и контролируй эффективность работы своих арбитражников.')}
					<h4 className="font-proxima-nova-semibold">{intl('Преимущества мастер-аккаунта для командной работы:')}</h4>
				</div>

				<div className="container__content-block">
					<div className="master-container__connect">
						<h3 className="info-title font-proxima-nova-semibold">
							{intl('Подключай к партнерке любое количество вебов')}
						</h3>
						{intl('Неважно сколько арбитражников у тебя в команде. Достаточно регистрации в нашей партнерке, ' +
							'чтобы добавить к своему мастер аккаунту каждого!')}
					</div>
					<div className="connect__screenshot"></div>
				</div>
				<div className="container__content-block">
					<div className="master-container__offer">
						<h3 className="info-title font-proxima-nova-semibold">
							{intl('Добавляй им приватные офферы и назначай индивидуальные ставки')}
						</h3>
						{intl('Ты можешь назначить любую ставку в рамках своей собственной. Даже если она выше базовой. ' +
							'Видишь, что кто-то из команды готов к новым вызовам - расшаривай эксклюзивный оффер ' +
							'и масштабируй доход.')}
					</div>
					<div className="offer__screenshot"></div>
				</div>
				<div className="container__content-block">
					<div className="master-container__statistic">
						<h3 className="info-title font-proxima-nova-semibold">
							{intl('Мониторь стату каждого веба в разрезе любых данных')}
						</h3>
						{intl('Прибыль команды зависит от слаженных действий всех участников. Решай кому и когда заменить ' +
							'транзитку или снизить стоимость закупки, чтобы не лить в минус - все данные у тебя под рукой.')}
					</div>
					<div className="statistic__screenshot"></div>
				</div>
				<div className="master-container__request">
					<div className="master-container__request--description">
						<span>Хочешь вывести работу команды на новый уровень?</span>
						<span>Пиши менеджеру насчет условий и доступа.</span>
					</div>
					<div>
						<Link
							className='button yellow-btn font-proxima-nova-semibold master-container__request--button'
							to={baseUrl('tickets/request/new-master/')}
							target="_blank">
							{intl('Запросить доступ')}
						</Link>
					</div>
				</div>
			</div>

			<div className="column_right">
				{ !isEmpty(props.manager) && <Manager data={props.manager} user={props.user} intl={intl} />  }
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		user: selectors.getUserData(state),
		manager: selectors.getManager(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/master-account/main.js